import { render } from "./TransactionList.vue?vue&type=template&id=5797b2e8&ts=true"
import script from "./TransactionList.vue?vue&type=script&lang=ts"
export * from "./TransactionList.vue?vue&type=script&lang=ts"

import "./TransactionList.vue?vue&type=style&index=0&id=5797b2e8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__